import { combineReducers } from '@reduxjs/toolkit';

import { reducer as applicationStateReducer } from '../slices/applicationState/slice';
import { reducer as authReducer } from '../slices/auth/slice';
import { reducer as configurationsReducer } from '../slices/configurations/slice';
import { reducer as environmentReducer } from '../slices/environment/slice';

const reducers = {
  applicationState: applicationStateReducer,
  auth: authReducer,
  configurationsState: configurationsReducer,
  environmentState: environmentReducer,
};

export const combinedReducers = combineReducers(reducers);
